import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { translate, Trans } from "react-i18next";

import consts from "consts/consts";

import { sendResetCode } from "actions/reset";

import Wrapper from "components/Wrapper";
import Title from "components/Title";
import Input from "components/Input";
import Button from "components/Button";
import InlineLink from "components/InlineLink";
import Label from "components/Label";
import Loader, { LoaderStyle } from "components/Loader";

import style from "./style.css";
import rootStyle from "../../style.css";

@translate()
@connect((state) => ({
  isLoading: state.reset.loading,
  wsSuccess: state.reset.success,
  wsError: state.reset.error,
}))
export default class PageReset extends Component {
  state = {
    error: undefined,
  };

  constructor(data) {
    super(data);
    this.customerCode = "";
  }

  onSubmitClick() {
    const nameApp = process.env.APP_MODE;
    const { t } = this.props;
    if (this.customerCode.length === 0) {
      this.setState({
        error: nameApp === consts.mode.heyfix ? t("_HEY_RESET_CUSTOMER_CODE_NOT_FILLED") : t("Please enter customer code as its required field."),
      });
      return;
    }
    if (this.customerCode.length > 9 && nameApp !== consts.mode.heyfix) {
      this.setState({
        error: t("Please enter maximum 9 character long text including dot."),
      });
      return;
    }
    this.setState({ error: undefined });
    this.props.dispatch(sendResetCode(this.customerCode));
  }

  onComponentDidMount() {
    let langCheck = setInterval(function(){
      let lngs = document.querySelectorAll('.b2c-global-header-language-menu li a');
      Array.prototype.forEach.call(lngs, function (lng) {
        let oldhref = lng.href;
        let href = lng.href.split('/');
        if (href[href.length-1].indexOf('lng') !== -1) {
            href = href[href.length-1].split('=');
        }
        let lang = href[href.length-1];
        lng.href = document.location.protocol + '//' + document.location.host + document.location.pathname + '?lng=' + lang;
        if (oldhref === lng.href) {
            clearInterval(langCheck);
        }
      });
    }, 300);

  }

  /**
   * Translate tag
   * @param {string} tag
   * @returns {*}
   */
  translate(tag) {
    const { t } = this.props;
    return t(tag);
  }

  onInputChange(event) {
    this.customerCode = event.target.value;
  }

  heyRender() {
    const validationError = this.state.error;
    const { isLoading, wsError, wsSuccess } = this.props;
    return (
      <Wrapper>
        <div className={rootStyle.fontWeightBold}>
          <Title><Trans>_HEY_RESET_TITLE</Trans></Title>
          <p><Trans>_HEY_RESET_INDICATION_INTRO</Trans></p>
          <p><Trans>_HEY_RESET_INDICATION_OUTRO</Trans></p>

          <ul>
            <li className={[rootStyle.mb4, rootStyle.listStyleStar].join(' ')}>
              <Trans>_HEY_RESET_ALREADY_CUSTOMER</Trans>
            </li>
            <li className={rootStyle.listStyleStar}>
              <Trans>_HEY_RESET_NEW_CUSTOMER</Trans>
            </li>
          </ul>

          <div className={[rootStyle.w100, rootStyle.displayFlex, rootStyle.flexDirectionRow, rootStyle.alignItemsCenter, rootStyle.mt24].join(' ')}>
            <Input type="text" onChange={this.onInputChange.bind(this)} onSubmit={this.onSubmitClick.bind(this)} placeholder={this.translate("_HEY_RESET_INPUT_PLACEHOLDER")} rootClassname={[rootStyle.m0, rootStyle.mr1].join(' ')} />
            <Button rootClassname={style.button} onClick={this.onSubmitClick.bind(this)}>
              {isLoading && <Loader rootClassname={style.loader} style={LoaderStyle.WHITE} />}
              {!isLoading && <Trans>_HEY_RESET_NEW_CODE_BUTTON</Trans>}
            </Button>
          </div>

          {!wsSuccess && (
            <div>
              <Fragment>
                {validationError && <p className={style.errorMessage}>{validationError}</p>}
                {wsError && !validationError && (
                    <p className={style.errorMessage}>
                      <Trans>_HEY_RESET_CUSTOMER_CODE_NOT_FOUND</Trans>
                    </p>
                  )}
              </Fragment>
            </div>
          )}
          {wsSuccess && (
            <div>
              <Fragment>
                <p className={style.successMessage}>
                  <Trans>_HEY_RESET_REQUEST_SENT</Trans>
                  <br />
                  <Trans>_HEY_RESET_SMS_NOT_RECEIVED</Trans>
                </p>
              </Fragment>
            </div>
          )}

          <div className={[rootStyle.w100, rootStyle.mt8].join(' ')}>
            <p>
              <InlineLink to="/" rootClassname={rootStyle.textDecorationNone}>
                <Trans>_HEY_RESET_HOME_LINK</Trans>
              </InlineLink>
            </p>
          </div>
        </div>
      </Wrapper>
  );
  }

  redirectToAppointment() {
    this.props.history.push(consts.routes.home.url);
  }

  orangeRender() {
    const validationError = this.state.error;
    const { isLoading, wsError, wsSuccess } = this.props;
    return (
      <Wrapper>
        <Title>
          <Trans>Resend my WeCareID-code</Trans>
        </Title>
        <p>
          <Trans>
            Please enter your 8-digits customer code over here, and then we will send your WeCareID-code via sms to your
            mobile.
          </Trans>
        </p>
        <ul>
          <li>
            <Trans>
              If you are already an existing Orange customer, you can find your customer code on your invoice or in your
              customer zone.
            </Trans>
          </li>
          <li>
            <Trans>If you are a new Love-customer, you can find your customer code on</Trans>
          </li>
        </ul>
        <Label>
          <Trans>Enter your customer-code to retrieve your WeCareID-code</Trans>
        </Label>
        <Input type="text" onChange={this.onInputChange.bind(this)} onSubmit={this.onSubmitClick.bind(this)} />
        {!wsSuccess && (
          <Fragment>
            <Button rootClassname={style.button} onClick={this.onSubmitClick.bind(this)}>
              {isLoading && <Loader rootClassname={style.loader} style={LoaderStyle.WHITE} />}
              {!isLoading && <Trans>Submit</Trans>}
            </Button>
            {validationError && <p className={style.errorMessage}>{validationError}</p>}
            {wsError &&
              !validationError && (
                <p className={style.errorMessage}>
                  <Trans>
                    Something went wrong in submitting your customer code. Please try again or call 5000 for support.
                  </Trans>
                </p>
              )}
          </Fragment>
        )}
        {wsSuccess && (
          <Fragment>
            <p className={style.successMessage}>
              <Trans>
                Thanks for submitting your customer code. We received your request. Within 1 minute you should receive
                an sms with your WeCareID-code.
              </Trans>
              <br />
              <Trans>
                If you didn't receive any sms from us, please verify your customer code and try again or call 5000 for
                support.
              </Trans>
            </p>
            <p>
              <Trans>
                Please copy the code you received in the sms to identify yourself and change your appointment date
              </Trans>
            </p>
            <Button rootClassname={style.button} onClick={this.redirectToAppointment.bind(this)}>
              <Trans>Change my appointment</Trans>
            </Button>
          </Fragment>
        )}
      </Wrapper>
    );
  }

  renderSwitch() {
    switch (process.env.APP_MODE) {
      case consts.mode.heyfix: return this.heyRender();
      default: return this.orangeRender();
    }
  }

  render() {
    return this.renderSwitch();
  }
}



// WEBPACK FOOTER //
// ./src/containers/PageReset/index.js